<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";

    import SettingsNav from "./settingsnav.svelte";
    import PaymentModule from "../admin/payment.svelte";

    import {
        errorReasons,
        paymentInfo,
        getSubscription
    } from "../api.svelte";


    const PAGE_TITLES = {
        'billing': 'Zahlung',
        'editplan': 'Zahlung anpassen',
        'editcard': 'Zahlungsmittel anpassen'
    };


    let currentView = 'billing';

    let userPaymentInfo;
    let vatPercentage = 7.7;

    $: showBackButton = () => {

        return currentView !== 'billing';
    };

    $: getPageTitle = () => {

        return PAGE_TITLES[currentView];
    };

    $: isStatic = () => {

        return currentView === 'billing';
    };

    $: isCardUpdate = () => {

        return currentView === 'editcard';
    };

    $: getCurrency = () => {

        return userPaymentInfo['details']['plan']['currency'];
    };

    $: getTier = () => {

        return userPaymentInfo['details']['plan']['nickname'].split('-')[0];
    };

    $: getPeriod = () => {

        return userPaymentInfo['details']['plan']['nickname'].split('-')[1];
    };

    $: getPaidProperties = () => {

        return userPaymentInfo['paid'];
    };

    $: getCardData = () => {

        return userPaymentInfo['paymentmethod'];
    };

    $: getSubscriptionData = () => {

        return {
            'status': userPaymentInfo['status'],
            'expiration': userPaymentInfo['expiration']
        };

    };


    onMount(() => {

        getPaymentInfo();

    });

    let getPaymentInfo = () => {

        paymentInfo('full').then((infoResult) => {

            if (infoResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(infoResult);

                return;

            }

            userPaymentInfo = infoResult['info'];

        });

    };

    let backButtonHandler = (evt) => {

        currentView = 'billing';
    };

    let editPlanHandler = () => {

        currentView = 'editplan';
    };

    let editCardHandler = () => {

        currentView = 'editcard';
    };

    let terminatedHandler = () => {

        getPaymentInfo();
    };

    let cardUpdatedHandler = () => {

        getPaymentInfo();
        currentView = 'billing';

    };

    let subscriptionUpdatedHandler = () => {

        getPaymentInfo();
        currentView = 'billing';

    };

</script>


<div class="settings-wrapper">

    <SettingsNav
            active="billing"
            showBack={showBackButton()}
            showDelete={false}
            on:back={backButtonHandler} />

    <h2>{getPageTitle()}</h2>

    <div id="payment-module-container">

        {#if userPaymentInfo}

            <PaymentModule
                    currency={getCurrency()}
                    tier={getTier()}
                    vatPercentage={vatPercentage}
                    currentPeriod={getPeriod()}
                    currentNumProperties={getPaidProperties()}
                    payButtonText="Änderung ausführen"
                    cardData={getCardData()}
                    subscriptionData={getSubscriptionData()}
                    isCardUpdate={isCardUpdate()}
                    isStatic={isStatic()}
                    showInlineCard={false}
                    showLogo={false}
                    on:editPlan={editPlanHandler}
                    on:editCard={editCardHandler}
                    on:subscriptionTerminated={terminatedHandler}
                    on:cardUpdated={cardUpdatedHandler}
                    on:subscriptionUpdated={subscriptionUpdatedHandler} />

        {/if}

    </div>

</div>


<style>

    #payment-module-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-top: 5vh;
        height: 60vh;
    }

</style>
